export const WalletView = () => {
    return(
        <p>Example</p>
    )
}